const fr = {
  login: {
    title: "Système de soumission des données",
    email: "Email",
    password: "Mot de passe",
    forgotPassword: "Mot de passe oublié",
    logout: "Déconnexion",
    inEmail: "Email incorrect",
    loginfailed: "Échec de la connexion, email ou mot de passe incorrect",
    enterEmail: "Veuillez saisir votre email",
    enterPassword: "Veuillez saisir votre mot de passe",
    enterCode: "Veuillez saisir le code de vérification",
    passwordNotMatch: "Les mots de passe ne correspondent pas",
  },
  forgot: {
    forgotPassword: "Mot de passe oublié",
    tip: "Nous vous enverrons un code de vérification à votre adresse email",
    email: "Email",
    code: "Code de vérification",
    password: "Mot de passe",
    confirmPassword: "Confirmez le mot de passe",
    send: "Envoyer",
    submit: "Soumettre",
    login: "Connexion",
  },
  menu: {
    mange: "Gestion des formulaires",
    mangeTip:
      "Création des formulaires de soumission de données, consultation des données",
    submission: "Remplir le formulaire",
    account: "Gestion des comptes",
    uwell: "Compte interne",
    external: "Compte externe",
  },
  editList: {
    fill: "Remplir",
    record: "Données",
    createdTime: "Date de création",
    formTitle: "Nom du formulaire",
    titleTip: "Veuillez saisir un titre",
    showInput:
      "Affichage des formulaires à remplir et des enregistrements de remplissage",
  },
  editFill: {
    save: "Sauvegarder",
    nosave:'Ne pas sauvegarder,',
    backSaveTip:'Voulez-vous sauvegarder le contenu saisi ?',
    submitted:'soumis',
    notsubmitted:'non soumis',

    submit: "Soumettre",
    submitSuccess: "Soumission réussie",
    fillAgain: "Remplir à nouveau",
    invalid: "Paramètre invalide",
    noTime: `Le formulaire n'est pas disponible pour le moment`,
    failedStop: `Échec de la soumission, le formulaire n'accepte plus de données`,
    failedNot: `Échec de la soumission, le formulaire n'existe pas`,
    failedPassed: `Échec de la soumission, le formulaire ne peut être rempli qu'une seule fois`,
    failedOnce: `Échec de la soumission, le formulaire ne peut être rempli qu'une fois par jour`,
    noempty: "Les champs obligatoires ne peuvent pas être vides",
  },
  editInfo: {
    SubmitTime: "Date de soumission",
    submitter:'Soumissionnaire',
    search: "Rechercher",
    clear: "Réinitialiser",
    filter: "Filtrer",
    fieldSetting: "Gestion des champs",
    export: "Exporter",
    createBy: "Créé par",
    updateTime: "Date de mise à jour",
    status:'état',
    action: "Action",
    detail: "Détails",
    edit: "Modifier",
    more:"Plus",
    copy:"Copie",
    startDate: "Date de début",
    endDate: "Date de fin",
    selectAll: "Tout sélectionner",
    confirm: "Confirmer",
    cancel: "Annuler",
    addFilter: "Ajouter un critère de filtrage",
    pleaseSelect: "Veuillez sélectionner",
    pleaseFillIn: "Veuillez remplir",
    delete: "Supprimer",
    filterIncom:
      "Le critère de filtrage de la ligne {num} est incomplet, veuillez vérifier",
    noData: "Aucune donnée disponible",
    uploadfailed: "Échec du téléchargement",
    total: "Total : {num} éléments",

    deleteTip : 'Cette opération supprimera les données. Voulez-vous continuer ?',
deleteSuccess : 'Suppression réussie'
  },
  fillIn: {
    equal: "Égal à",
    noequal: "Différent de",
    contains: "Contient",
    notcontains: "Ne contient pas",
    empty: "Vide",
    notempty: "Non vide",
    before: "Avant",
    after: "Après",
    greaterequal: "Supérieur ou égal à",
    lessequal: "Inférieur ou égal à",
    greaterthan: "Supérieur à",
    lessthan: "Inférieur à",
  },
  editEye: {
    detail: "Données du formulaire",
  },
  editUpdate: {
    editForm: "Modifier le formulaire",
    returnList: "Retour à la liste",
  },
};

export default fr;
